import React from "react";

const OrderCart = ({ orderCount, tableData, onClickAddNoOrderButton }) => {

    return (
        <div>
            <div style={{ maxWidth: "550px", margin: '0 auto', marginBottom: '20px' }}>

                <div className='mb-3 center-block-column'>
                    {(tableData || []).map((orderCart, index) => (
                        <div key={index} 
                        className='info-card'
                            // style={{ animationDelay: `${index * 0.6}s` }}
                        >
                            {orderCart.showData.jsx}
                        </div>
                    ))}
                </div>


                {orderCount > 0 ? <div style={{
                    padding: '5px',
                    background: 'chartreuse',
                    borderRadius: '15px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '1rem'
                }}>
                    <span>Proceed to order ({orderCount} item{orderCount > 1 ? "s" : ""})</span>
                </div> :
                    <div style={{
                        padding: '5px',
                        background: 'chartreuse',
                        borderRadius: '15px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)',
                        minWidth: '300px'
                    }} onClick={onClickAddNoOrderButton}>
                        <span>No order in Order Cart!</span><br /><span>Click Here to add order!</span>
                    </div>
                }
            </div>
        </div>
    );
};

export default OrderCart;